import React from 'react';
import './App.scss';
import Hero from './Components/Hero/Hero';
import Footer from './Components/Footer/Footer';
import Header from './Components/common-header/Header';
import Gallery from './Components/Gallery/Gallery';
import Copy1 from './Components/Copies/Copy1';
import Copy2 from './Components/Copies/Copy2';
// import Copy3 from './Components/Copies/Copy3';
import Copy4 from './Components/Copies/Copy4';
import Copy5 from './Components/Copies/Copy5';
import Copy6 from './Components/Copies/Copy6';
import Copy7 from './Components/Copies/Copies7';
import Copy8 from './Components/Copies/Copies8';
import Citation from './Components/Citation/Citation';
import Citation2 from './Components/Citation/Citation2';
import Poll from './Components/Poll/Poll';
import photoD1 from './assets/gallery/gallery1/d1.jpg';
import photoD2 from './assets/gallery/gallery1/d2.jpg';
import photoD3 from './assets/gallery/gallery1/d3.jpg';
import photoD4 from './assets/gallery/gallery1/d4.jpg';
import photoD5 from './assets/gallery/gallery1/d5.jpg';

import photoM1 from './assets/gallery/gallery1/m1.jpg';
import photoM2 from './assets/gallery/gallery1/m2.jpg';
import photoM3 from './assets/gallery/gallery1/m3.jpg';
import photoM4 from './assets/gallery/gallery1/m4.jpg';
import photoM5 from './assets/gallery/gallery1/m5.jpg';

const galleryData1 = {
  name: 'Daniel Boey',
  photos: [
    {
      title: 'Daniel Boey Today',
      desktop: photoD1,
      mobile: photoM1,
      desc: `Daniel Boey has been in the fashion business for more than 30 years, but it has been a hard 
      road to build the confidence he has today. `,
      number: 1
    },
    {
      title: 'Childhood',
      desktop: photoD2,
      mobile: photoM2,
      desc: `Boey’s journey with eczema started at the beginning of his life. As a child, he didn’t have a 
      chance to connect with others dealing with the same skin issues. “Families teach you how to 
      hide your imperfections,” Boey says of growing up in Asia concealing his skin condition.`,
      number: 2
    },
    {
      title: ' Early Career In Fashion',
      desktop: photoD3,
      mobile: photoD3,
      desc: `Early in his modeling career, Boey recalls needing to wear outfits that would cause flare-ups. 
      These days it’s different, and he can pass on irritating fabrics and prioritize his health, “And if I 
      lose the job, I lose the job, you know?” `,
      number: 3
    },
    {
      title: 'Life In The Fashion World/TV Career',
      desktop: photoD4,
      mobile: photoD4,
      desc: `“I think in this age of social media, [it] can be very toxic but social media can also be very good if
      you allow it to [be],” Boey says about his life in the spotlight. People reach out to him when he 
      speaks out about eczema, and he embraces the chance to connect with other eczema warriors.`,
      number: 4
    },
    {
      title: 'Eczema Advocate',
      desktop: photoD5,
      mobile: photoD5,
      desc: `As a way to connect, Boey wrote a book about his struggles with eczema. It includes humorous 
      takes on his personal experiences and Boey is happy to put himself out there. “I wish there were
      people who appeared on TV, appeared in magazines, when I was younger, who had the same 
      condition, who looked like me, so I knew that I wasn't alone,” he says.`,
      number: 5
    }
  ]
};
const pollQuestions = [
  {
    qCopy: 'What is the percentage of adult eczema patients who have moderate-to-severe disease?',
    choice1: '33%',
    choice2: '25%',
    index: 0
  },

  {
    qCopy:
      'On average, how many workdays or school days do people with atopic dermatitis miss each year because of their condition?',

    choice1: '>5',
    choice2: '<5',
    index: 1
  },
  {
    qCopy: 'What percent of children with atopic dermatitis have experienced sleep disruption?',

    choice1: '>50%',
    choice2: '<50%',
    index: 2
  }
];

function App() {
  return (
    <main className="App">
      <Header />
      <Hero />
      <Copy1 />
      <Copy2 />
      <Poll pollQuestions={pollQuestions[0]} />
      {/* <Copy3 /> */}
      <Copy4 />
      <Poll pollQuestions={pollQuestions[1]} />
      <Copy5 />
      <Gallery galleryData1={galleryData1} />
      <Copy6 />
      <Poll pollQuestions={pollQuestions[2]} />
      <Copy7 />
      <Copy8 />
      {/* <Citation2 />
      <Citation /> */}
      <Footer />
    </main>
  );
}

export default App;
